import { getContext, setContext } from "svelte"
import { writable } from "svelte/store"

/**
 * @typedef {import("svelte").Writable} SvelteWritable
 */

/**
 * @typedef {{
 *   backend: {
 *     version: string | null,
 *   },
 *   experimental: {
 *     features: string[],
 *     views: string[],
 *   },
 *   frontend: {
 *     version: string | null,
 *   },
 *   language: string,
 *   package: {
 *     version: string,
 *   },
 *   packages: {
 *     autoMps: {
 *       enabled: boolean,
 *       allowed: boolean,
 *     }
 *   },
 * }} AppContextValueType
 */

/**
 * @type {AppContextValueType}
 */
const defaultAppContextValue = {
  backend: {
    version: null,
  },
  experimental: {
    features: [],
    views: [],
  },
  frontend: {
    version: null,
  },
  language: "en",
  package: {
    version: null,
  },
  packages: {
    autoMps: {
      enabled: false,
      allowed: false,
    }
  }
}

/**
 *
 * @param {AppContextValueType | undefined} initialValues
 * @returns {SvelteWritable<AppContextValueType>}
 */
const createAppContextValueStore = (initialValues) => {
  return writable(initialValues ?? defaultAppContextValue)
}

const appContextSymbol = Symbol("appContext")

/**
 *
 * @returns {SvelteWritable<AppContextValueType>}
 */
export function getAppContext() {
  return getContext(appContextSymbol)
}

/**
 *
 * @param {AppContextValueType} [appContextValue]
 * @returns {SvelteWritable<AppContextValueType>}
 */
export function setAppContext(appContextValue) {
  const store = createAppContextValueStore(appContextValue)
  setContext(appContextSymbol, store)
  return store
}
